import { render, staticRenderFns } from "./order-detail-box.vue?vue&type=template&id=164d3b9e&scoped=true&"
import script from "./order-detail-box.vue?vue&type=script&lang=js&"
export * from "./order-detail-box.vue?vue&type=script&lang=js&"
import style0 from "./order-detail-box.vue?vue&type=style&index=0&id=164d3b9e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164d3b9e",
  null
  
)

export default component.exports